import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin } from "antd";
import {
  MinusSquareFilled,
  PlusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { getRequest, patchRequest } from "../../axios";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import ButtonField from "../../common/htmlComponents/ButtonField";

const KeyPersonVendor = ({
  VendorId,
  keypersonId,
  setKeyPersonId,
  gstVendorId,
  setShowVendorBillingDetails,
  gstValue,
}) => {
  const formRef = useRef();
  const { t } = useTranslation();

  const initialState = {
    keypersons: [
      {
        person_name: null,
        email: null,
        designation: null,
        contact_number: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);

  const [apiLoading, setapiloading] = useState(false);

  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.keypersons;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, keypersons: newPersonArr });
  };
  const removePerson = async (lastIndex) => {
    let filterPersonArr = state.keypersons.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, keypersons: filterPersonArr });
    setWeightSizeFieldValue(filterPersonArr);
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    console.log(data);
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["person_name" + objectKey] = objectValue.person_name;
      fieldObject["email" + objectKey] = objectValue.email;
      fieldObject["designation" + objectKey] = objectValue.designation;
      fieldObject["contact_number" + objectKey] = String(
        objectValue.contact_number || "+91"
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };
  const addPerson = () => {
    let newPersonArr = [
      ...state.keypersons,
      {
        person_name: null,
        email: null,
        designation: null,
        contact_number: null,
      },
    ];
    setState({ ...state, keypersons: newPersonArr });
    setWeightSizeFieldValue(newPersonArr);
  };
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.keypersons;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, keypersons: newPersonArr });
  };

  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const vendor = gstVendorId ? gstVendorId : VendorId;
        const apiResponse = await getRequest(
          `vendor-keypersons/?vendor=${VendorId}`
        );
        if (apiResponse.data.success) {
          if (apiResponse.data.success) {
            setState({
              // ...filteredResponse,

              keypersons: apiResponse.data.data.map((keyPerson) => {
                const { id, vendor, vendor_name, ...rest } = keyPerson;
                return rest;
              }),
            });

            const modifiedKeypersons = apiResponse.data.data.map(
              (keypersonDetail) => {
                const { id, vendor, vendor_name, ...rest } = keypersonDetail;
                return rest;
              }
            );
            setWeightSizeFieldValue(modifiedKeypersons);

            if (VendorId !== null) {
              // setIsGstNoReadOnly(true);
            }
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    const getGstVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `vendor-keypersons/keyperson-by-gst/?gst_no=${gstValue}`
        );

        if (apiResponse.data.success) {
          console.log(apiResponse);
          setKeyPersonId(apiResponse?.data?.data[0]?.id);
          setState({
            // ...filteredResponse,

            keypersons: apiResponse.data.data.map((keyPerson) => {
              const { id, vendor, vendor_name, ...rest } = keyPerson;
              return rest;
            }),
          });

          const modifiedKeypersons = apiResponse.data.data.map(
            (keypersonDetail) => {
              const { id, vendor, vendor_name, ...rest } = keypersonDetail;
              return rest;
            }
          );
          setWeightSizeFieldValue(modifiedKeypersons);

          if (VendorId !== null) {
            //setIsGstNoReadOnly(true);
          }
        } else if (apiResponse.data.success === false) {
          console.log(apiResponse);
          setState({
            keypersons: apiResponse.data.data.map((keyPerson) => {
              const { id, vendor, vendor_name, ...rest } = keyPerson;
              return rest;
            }),
          });

          const modifiedKeypersons = apiResponse.data.data.map(
            (keypersonDetail) => {
              const { id, vendor, vendor_name, ...rest } = keypersonDetail;
              return rest;
            }
          );
          setWeightSizeFieldValue(modifiedKeypersons);
          setKeyPersonId(null);
          if (VendorId !== null) {
            //setIsGstNoReadOnly(true);
          }
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    if (VendorId !== null && gstVendorId === null) {
      getVendorOnboarding();
    }
    if (gstVendorId !== null) {
      getGstVendorOnboarding();
    }
  }, [VendorId, gstVendorId, t, gstValue]);
  const handleSubmit = async () => {
    const payload = {
      keypersons:
        state.keypersons &&
        state.keypersons.every(
          (person) =>
            person.person_name === null &&
            person.email === null &&
            person.designation === null &&
            person.contact_number === null
        )
          ? []
          : state.keypersons,
    };
    try {
      setBtnLoading(true);
      let response;
      if (keypersonId === null) {
        const url =
          VendorId !== null
            ? `vendor-keypersons/${VendorId}/add-keypersons/`
            : `vendor-keypersons/${gstVendorId}/add-keypersons/`;
        response = await patchRequest(url, payload);
      } else {
        const url =
          VendorId !== null
            ? `vendor-keypersons/${VendorId}/`
            : `vendor-keypersons/${gstVendorId}/`;

        response = await patchRequest(url, payload);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          keypersonId === null
            ? t("keyperson_added_successfully")
            : t("keyperson_updated_successfully")
        );
        console.log("response", response);

        setKeyPersonId(response.data.data.keypersons[0].id);
        setShowVendorBillingDetails(true);
        setBtnLoading(false);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  return (
    <><div className="FormBody">
      <Spin spinning={apiLoading}>
        <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
          {state.keypersons &&
            state.keypersons.map((x, index) => {
              return (
                <>
                <Row key={index} className="customcol" gutter={[16]}>
                <Col xs={22} sm={22} md={22} xl={22} xxl={22}>
                <Row gutter={[16]}>
                    <Col xs={24} sm={12}  xl={6} xxl={6}
                    >
                      <Form.Item
                        name={`person_name` + index}
                        label={t("pl_personName")}
                        rules={[
                          {
                            required: false,
                            message: <Trans>{t("pl_gst")}</Trans>,
                          },
                          {
                            pattern: /^[a-zA-Z_ ]+$/,
                            message: "Please Enter Valid Name",
                          },
                          {
                            min: 2,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 20,
                            message: <Trans>{t("maxlength_personName")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("pl_personName")}
                          onChange={(value) =>
                            handleCloneInputChange("person_name", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}  xl={6} xxl={6}
                    >
                      <Form.Item
                        name={`designation` + index}
                        label={t("label_designation")}
                        rules={[
                          {
                            min: 3,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 30,
                            message: (
                              <Trans>{t("maxlength_designation")}</Trans>
                            ),
                          },
                          {
                            pattern: /^[A-Za-z\s]+$/,
                            message: <Trans>{t("Please Enter Valid Designation")}</Trans>,
                          },
                        ]}
                        
                      >
                        <Input
                          placeholder={t("pl_designation")}
                          onChange={(value) =>
                            handleCloneInputChange("designation", value, index)
                          }
                          
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}  xl={6} xxl={6}
                    >
                      <Form.Item
                        name={`email` + index}
                        label={t("lbb_email")}
                        rules={[
                          {
                            type: "email",
                            message: <Trans>{t("val_email")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          placeholder={t("pl_email")}
                          onChange={(value) =>
                            handleCloneInputChange("email", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} xl={6} xxl={6}
                    >
                      <Form.Item
                        name={`contact_number` + index}
                        label={t("pl_ContactNo")}
                        pattern={"/^d{12}$/"}
                        rules={[
                          {
                            message: <Trans>{t("val_phone")}</Trans>,
                          },
                          {
                            pattern: /^\d{12}$/,
                            message: <Trans>{t("val_phone")}</Trans>,
                          },
                        ]}
                      >
                        <PhoneInput
                          className="PhoneSection"
                          country={"in"}
                          onChange={(phone) =>
                            handleClonePhoneInputChange(
                              "contact_number",
                              phone,
                              index
                            )
                          }
                        />
                      </Form.Item>
                    </Col>
                  
                  </Row>
                </Col>
                <Col xs={24} sm={2} md={2} xl={2} xxl={2}>
                <div className="addwrp">
                        <Space>
                          {index !== 0 ? (
                            <MinusSquareFilled
                              className="add"
                              onClick={() => removePerson(index)}
                            />
                          ) : (
                            ""
                          )}

                          <PlusSquareFilled
                            className="add"
                            onClick={(e) => addPerson(e)}
                          />
                        </Space>
                      </div>
                </Col>
             
                </Row>
                
                </>
              );
            })}
          {VendorId || gstVendorId ? (
            <div className="subbuttonsrow">
              <ButtonField
                type="primary"
                icon={<SaveOutlined />}
                onClick={handleSubmit}
                label={t("save")}
                loading={btnLoading}
              />
            </div>
          ) : (
            ""
          )}
        </Form>
      </Spin>
      </div>
    </>
  );
};
KeyPersonVendor.propTypes = {
  VendorId: PropTypes.number,
  keypersonId: PropTypes.number,
  setKeyPersonId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
  setShowVendorBillingDetails: PropTypes.func,
};
export default KeyPersonVendor;
